import Button from 'components/ui/Button';
import { styled, ThemeColors } from 'styled-components';

type SecondaryActionButtonProps = {
    disabled: boolean;
    onClick: () => void;
    title: string;
    children: React.ReactNode;
    height?: number;
    bgColor?: keyof ThemeColors;
    backgroundColor?: string;
    rounded?: boolean;
};

const SecondaryActionButton: React.FC<SecondaryActionButtonProps> = ({
    disabled,
    onClick,
    title,
    children,
    rounded = true,
    height = 30,
    bgColor = 'fillWhite',
    backgroundColor,
}) => (
    <StyledButton
        flex
        height={height}
        disabled={disabled}
        bgColor={backgroundColor ? undefined : bgColor}
        $backgroundColor={backgroundColor}
        color={backgroundColor ? undefined : 'text'}
        rounded={rounded}
        border={!disabled}
        onClick={onClick}
        title={title}
    >
        {children}
    </StyledButton>
);

export default SecondaryActionButton;

const StyledButton = styled(Button)<{ $backgroundColor?: string }>`
    border: 1px solid ${({ theme }) => theme.colors.border};
    min-width: 150px;
    padding: 0.55rem 0.75rem;
    background-color: ${({ $backgroundColor }) => ($backgroundColor ? $backgroundColor : '')};
`;
